
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import HistoriaClinica from './modules/HistoriaClinica';
import ChatBox from './modules/ChatBox';
import ControlPanel from './modules/ControlPanel.js';
import Notificaciones from './modules/Notificaciones';
import doctorNotificaciones from './modules/doctorNotificaciones';
import storeAgendamiento from './modules/storeAgendamiento';


Vue.use(Vuex);
export const store = new Vuex.Store({
  modules: {
    HistoriaClinica,
    ChatBox,
    ControlPanel,
    Notificaciones,
    doctorNotificaciones,
    storeAgendamiento,
  },
  state: {
    userlogged: null,
    provider_id: null,
    user: null,
    provider_email: null,
    auth: false,
    gmailUserImage: null,
    token: null
    // estados_panel_lateral_vuex:null
  },
  getters: {
    // cambiaPanelLateral: state => state.estados_panel_lateral_vuex
    getToken: state => state.token
  },
  mutations: {
    saveUserLogged(state, loggedUser) {
      state.userlogged = loggedUser;
    },
    saveUser(state, User) {
      state.user = User;
    },
    saveToken(state, token) {
      state.token = token;
    },
    saveProviderId(state, id) {
      state.provider_id = id;
    },
    saveEmail(state, email) {
      state.provider_email = email;
    },
    saveUserImage(state, userImage) {
      state.gmailUserImage = userImage;
    },
    change_auth(state) {
      state.auth = !state.auth;
      console.log('mutations fired', auth);
    },
    /*
    setestadoPanel(state, valor){
      state.estados_panel_lateral_vuex = valor
    } */
  },
  actions: {
    saveUserLogged(context, loggedUser) {
      context.commit('saveUserLogged', loggedUser);
    },
    saveUser(context, User) {
      context.commit('saveUser', User);
    },
    saveToken(context, token) {
      context.commit('saveToken', token);
    },
    saveProviderId(context, id) {
      context.commit('saveProviderId', id);
    },
    saveEmail(context, id) {
      context.commit('saveEmail', id);
    },
    saveUserImage(context, userImage) {
      context.commit('saveUserImage', userImage);
    },
    /*
    setestadoPanel(context,estado){
      context.commit("setestadoPanel", estado);
    } */
  },
  plugins: [createPersistedState()],
});



// WEBPACK FOOTER //
// ./src/js/store.js